import { Flex } from '@chakra-ui/react';
import type { ReactNode } from 'react';

type PageWrapperProps = {
  children?: ReactNode;
};

export function PageWrapper({ children }: PageWrapperProps) {
  return (
    <Flex width="100%" height="100vh" overflow="auto" direction="column">
      {children}
    </Flex>
  );
}
